import * as mt from './mutation-types';

import { RootState } from '../types';
import { VegetationIndexState, VegetationIndexPayload, VegetationIndexCropPayload } from './types';
import { ActionContext } from 'vuex';

type VegetationIndexContext = ActionContext<VegetationIndexState, RootState>;

export default {
  [mt.CLEANUP]({ commit }: VegetationIndexContext) {
    commit(mt.CLEANUP);
  },
  [mt.FETCHING_VEGETATION_INDEX_AVERAGE]({ commit }: VegetationIndexContext, uuid: string) {
    commit(mt.FETCHING_VEGETATION_INDEX_AVERAGE, { uuid });
  },
  [mt.FETCH_VEGETATION_INDEX_AVERAGE]({ commit }: VegetationIndexContext, payload: VegetationIndexPayload) {
    commit(mt.FETCH_VEGETATION_INDEX_AVERAGE, payload);
  },
  [mt.FETCH_FAILURE]({ commit }: VegetationIndexContext, uuid: string) {
    commit(mt.FETCH_FAILURE, { uuid });
  },
  [mt.FETCHING_VEGETATION_INDEX_CROP]({ commit }: VegetationIndexContext, uuid: string) {
    commit(mt.FETCHING_VEGETATION_INDEX_CROP, { uuid });
  },
  [mt.FETCH_VEGETATION_INDEX_CROP]({ commit }: VegetationIndexContext, payload: VegetationIndexCropPayload) {
    commit(mt.FETCH_VEGETATION_INDEX_CROP, payload);
  },
  [mt.FETCH_CROP_FAILURE]({ commit }: VegetationIndexContext, uuid: string) {
    commit(mt.FETCH_CROP_FAILURE, { uuid });
  },
  [mt.FETCHING_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED]({ commit }: VegetationIndexContext, uuid: string) {
    commit(mt.FETCHING_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED, { uuid });
  },
  [mt.FETCH_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED]({ commit }: VegetationIndexContext, payload: VegetationIndexPayload) {
    commit(mt.FETCH_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED, payload);
  },
  [mt.FETCH_FAILURE]({ commit }: VegetationIndexContext, uuid: string) {
    commit(mt.FETCH_FAILURE_FOR_CROP_TYPE_NOT_CONFIRMED, { uuid });
  },
};
